var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn--alpha",attrs:{"type":"button"},on:{"click":_vm.handleUploadClick}},[_vm._v(" "+_vm._s(_vm.$t('DOCUMENT_WIZARD.UPLOAD_NEW_VERSION'))+" ")]),_c('input',{ref:"filesRef",staticClass:"hidden-dms",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.handleChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }